// extracted by mini-css-extract-plugin
export default {"root":"side_panel_header-module___root___ef2ec93b","title":"side_panel_header-module___title___dbdd87ef","toggleWrapper":"side_panel_header-module___toggleWrapper___dfbc0ae4"};